module.exports = "<p>\n  closed-form works!\n</p>\n"